// extracted by mini-css-extract-plugin
module.exports = {"confirmationContainer":"_3jaWT37T","editContent":"_1L7JU7Di","footer":"mH9vj7cv","submitBtn":"_3OsAHm5t"};